<template>
  <div>
    <upload-file-form
      ref="uploadArquivo"
      v-if="!!importacao"
      :title="!!importacao ? `${$t('label.fazer_nova_importacao_de')} ${importacao.titulo}` : $t('label.fazer_nova_importacao')"
      :auto-process-queue="false"
      @UploadArquivo__success="uploadSuccess"
      @UploadArquivo__error="uploadError"
      @UPLOADFILE_SENDING="enviandoArquivo"
      :maxFileSizeInMB="50"
      :url="uploadFileUrl"
      :accepted-file-types="importacao.arquivosSuportados"
      :custom-validate="validaMesesImportacao"
      >

      <v-date-picker
        locale="pt-br"
        v-model="mesesImportacao"
        type="month"
        no-title
        color="primary"
        multiple/>
    </upload-file-form>

    <v-dialog v-model="exibeModalExportacao" content-class="NotasExportacao__SelecaoPeriodo">
      <v-card fluid v-if="!!itemExportacao">
        <v-radio-group
          v-if="!isInconsistencia(itemExportacao.titulo)"
          v-model="tipoData"
          class="ma-0 ml-4 pa-2"
          hide-details
          :label="$t('label.aplicar_se_a')">
          <v-radio
            color="primary"
            :label="$t('label.data_emissao')"
            value="dataEmissao" v-if="itemExportacao.tipo === 'SELLIN' || itemExportacao.tipo === 'DEVOLUCAO'">
          </v-radio>
          <v-radio
            color="primary"
            :label="$t('label.data_pedido')"
            value="dataPedido" v-if="itemExportacao.tipo === 'CARTEIRA' || itemExportacao.tipo === 'REMESSA'">
          </v-radio>
        </v-radio-group>

        <v-radio-group
          v-if="isInconsistencia(itemExportacao.titulo)"
          v-model="inconsistenciasTrataveis"
          class="ma-0 ml-4 pa-2"
          hide-details
          :label="$t('label.aplicar_se_a')">
          <v-radio
            color="primary"
            :label="$t('label.trataveis')"
            value="true" v-if="itemExportacao.tipo === 'INCONSISTENCIA'">
          </v-radio>
          <v-radio
            color="primary"
            :label="$t('label.nao_trataveis')"
            value="false" v-if="itemExportacao.tipo === 'INCONSISTENCIA'">
          </v-radio>
        </v-radio-group>

        <v-date-picker
          locale="pt-br"
          v-model="mesesExportacao"
          type="month"
          no-title
          color="primary"
          multiple>
          <v-spacer></v-spacer>
          <v-btn text color="primary"
            @click.native="fecharModalCalendario(itemExportacao.ordenacao - 1)">
              {{ $t('label.cancelar') }}
          </v-btn>
          <v-btn text color="primary"
            @click.native="abrirModalConfirmacao('exportar', itemExportacao)">
            {{ $t('label.confirmar') }}
          </v-btn>
        </v-date-picker>
      </v-card>
    </v-dialog>

    <v-container fluid px-0 py-2 class="Container_Nivel1_Notas">
      <v-data-iterator
        :items="listaCards"
        hide-default-footer
        v-show="!esperar"
        :no-data-text="$t('label.tabela_sem_conteudo')"
        :footer-props="{
          itemsPerPageOptions: [4],
        }">
        <template v-slot:default="props">
          <v-row justify="center">
            <v-col
              v-for="item in props.items"
              :key="item.ordenacao"
              cols="12"
              sm="6"
             md="4"
              lg="3"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card :class="`elevation-${hover ? 5 : 1}`" class="clickable Card_Notas fill-height">
                  <v-card-title class="Card_Title pa-2" @click="selectItem(item)">
                    <p>{{ item.titulo }}</p>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text @click="selectItem(item)" class="Card_Content pa-0">
                    <v-row justify="center" align="center">
                      <v-col cols="12" v-if="!isInconsistencia(item.titulo)">
                        <p>
                          <span class="subheading">{{ $t('label.valor_bruto') }}</span> <br />
                          <span class="title">{{ getMoney(item.valorTotal) }}</span>
                        </p>
                        <p>
                          <span class="subheading">{{ $t('label.valor_liquido') }}</span> <br />
                          <span class="title">{{ getMoney(item.valorLiquido) }}</span>
                        </p>
                      </v-col>
                      <v-col cols="12" v-if="isInconsistencia(item.titulo)">
                        <p>
                          <span class="subheading">{{ $t('label.valor_total') }}</span> <br />
                          <span class="title">{{ getMoney(item.valorTotal) }}</span>
                        </p>
                        <p>
                          <span class="subheading">{{ $t('label.valor_liquido') }}</span> <br />
                          <span class="title">{{ getMoney(item.valorLiquido) }}</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="Card_Actions">
                    <v-row justify="end">
                      <v-spacer />
                      <v-tooltip bottom v-if="podeImportar(item) && !isInconsistencia(item.titulo)">
                        <template v-slot:activator="{ on }">
                          <v-btn icon
                            v-on="on"
                            @click="abrirSidebardUpload(item)">
                            <v-icon>
                              cloud_upload
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('label.importar') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn icon
                            v-on="on"
                            @click="exibeDialogExportacao(item)">
                            <v-icon>
                              get_app
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('label.exportar') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="!isInconsistencia(item.titulo)">
                        <template v-slot:activator="{ on }">
                          <v-btn icon
                            v-on="on"
                            @click="exportaModelo(item)">
                            <v-icon>
                              font_download
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('label.exportar_modelo') }}</span>
                      </v-tooltip>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
    <confirm
      ref="modalConfirmacao"
      :message="mensagemConfirmacao"
      @agree="confirmaExportacao"
      @disagree="cancelarExportacao">
    </confirm>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { basePath } from '@/common/resources/importacoes';
import { getMoney } from '../../produto/common/functions/helpers';
import { generateComputed } from '../../produto/common/functions/roles-computed-generator';
import Confirm from '../../produto/shared-components/vuetify/dialog/Confirm';

import UploadFileForm from '../../produto/shared-components/upload/UploadFileForm';

export default {
  name: 'NotasNivel1DadosAgrupado',
  components: {
    Confirm,
    UploadFileForm,
  },
  props: {
    exibeImportador: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resources: this.$api.notas(this.$resource),
      listaCards: [],
      rowsPerPageItems: [4],
      esperar: false,
      menu: [
        false,
        false,
        false,
      ],
      date: new Date().toISOString().substr(0, 10),
      mensagemConfirmacao: '',
      bloquearBotaoExportacao: false,
      notaSelecionada: {},
      mesesExportacao: [],
      mesesImportacao: [],
      tipoData: null,
      inconsistenciasTrataveis: null,
      abrirImportacao: false,
      exibeModalExportacao: false,
      itemExportacao: null,
      importacao: null,
    };
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('implantacao', [
      'indModoVarejo',
    ]),
    ...generateComputed('NOTA', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    ...mapGetters('importacao', {
      tiposImportacao: 'getTiposImportacao',
    }),
    tipoImportacaoSellin() {
      return this.tiposImportacao.filter((t) => t.nome.indexOf('sellin') >= 0)[0];
    },
    tipoImportacaoPedido() {
      return this.tiposImportacao.filter((t) => t.nome.indexOf('pedido') >= 0)[0];
    },
    uploadFileUrl() {
      return this.importacao
        ? `${basePath}importacao`
        : null;
    },
    podeImportarNotas() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'SELLIN_IMPORTAR').length;
    },
    podeImportarPedidos() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'PEDIDOS_IMPORTAR').length;
    },
  },
  methods: {
    getMoney,
    validaMesesImportacao() {
      if (this.mesesImportacao.length === 0) {
        this.$toast(this.$t('message.mes_importacao_obrigatorio'), 'bottom', 8E3);
        return false;
      }
      return true;
    },
    podeImportar(item) {
      if (item.titulo.includes('Pedido')) {
        return this.podeImportarPedidos;
      }
      return this.podeImportarNotas;
    },
    enviandoArquivo(data, xhr, formData) {
      const parametros = { meses: this.mesesImportacao };
      if (this.importacao.titulo.includes('Pedido')) {
        parametros.tipo = this.importacao.tipo;
      }

      formData.append('id_tipo_importacao', this.importacao.id);
      formData.append('parametros', JSON.stringify(parametros));
    },
    abrirSidebardUpload(item) {
      if (item.titulo.includes('Pedido')) {
        this.importacao = {
          ...this.tipoImportacaoPedido,
          ...item,
        };
      } else {
        this.importacao = {
          ...this.tipoImportacaoSellin,
          ...item,
        };
      }

      setTimeout(() => this.$refs.uploadArquivo.open());
    },
    exibeDialogExportacao(item) {
      this.tipoData = item.tipo === 'SELLIN' || item.tipo === 'DEVOLUCAO' ? 'dataEmissao' : 'dataPedido';
      this.itemExportacao = item;
      this.exibeModalExportacao = true;
      this.inconsistenciasTrataveis = null;
      this.mesesExportacao = [];
    },
    uploadError(file, msg) {
      this.$toast(msg || this.$t('message.erro_tente_importar_novamente'));
    },
    uploadSuccess() {
      this.$toast(this.$t('message.importado_em_breve_sera_processado'), 'bottom', 8E3);
      this.mesesImportacao = [];
      this.$refs.uploadArquivo.close();
    },
    selectItem(item) {
      this.$emit('Notas__SelecionaItemNivel1', item);
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    buscar() {
      this.resources.listarNotasAgrupadasPorTipo().then((response) => {
        this.listaCards = response.data;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    abrirModalConfirmacao(acao, nota) {
      this.exibeModalExportacao = false;

      if (acao !== 'exportar') {
        return;
      }
      if (nota && nota.tipo === 'INCONSISTENCIA' && this.inconsistenciasTrataveis === null) {
        this.$toast(this.$t('errors.inconsistencia.inconsistencia_nao_selecionada'));
        return;
      }
      if (!this.mesesExportacao.length) {
        this.$toast(this.$t('errors.periodo.obrigatorio'));
        return;
      }
      this.bloquearBotaoExportacao = true;
      this.notaSelecionada = nota;
      this.mensagemConfirmacao = this.$t('message.deseja_exportar');
      setTimeout(() => this.$refs.modalConfirmacao.open());
    },
    fecharModalCalendario(index) {
      this.menu[index] = false;
      this.exibeModalExportacao = false;
      this.$forceUpdate();
    },
    exportaModelo(item) {
      this.notaSelecionada = item;
      this.$emit('TABELA_EXPORTAR_MODELO', this.notaSelecionada.tipo);
    },
    confirmaExportacao() {
      const tipoNota = this.notaSelecionada.tipo;
      const meses = this.mesesExportacao
        .map((m) => parseInt(m.split('-').join(''), 10));
      const { tipoData } = this;
      const { inconsistenciasTrataveis } = this;

      this.resources.verificarDadosExportacaoPedido({
        tipoNota, meses, tipoData, inconsistenciasTrataveis,
      })
        .then((response) => {
          this.pararEsperar();
          if (response.body) {
            this.$emit('TABELA_EXPORTAR_DADOS',
              () => { this.bloquearBotaoExportacao = false; },
              this.notaSelecionada, meses, this.tipoData, this.inconsistenciasTrataveis);
          } else {
            this.bloquearBotaoExportacao = false;
            this.$toast(this.$t('message.sem_dados_exportacao_periodo'));
          }
        }).catch((err) => {
          this.pararEsperar();
          this.$error(this, err);
        }).finally(() => {
          this.bloquearBotaoExportacao = false;
          this.mesesExportacao = [];
        });
    },
    cancelarExportacao() {
      this.bloquearBotaoExportacao = false;
      this.notaSelecionada = {};
    },
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast('Acesso negado');
      }
    },
    isInconsistencia(titulo) {
      return titulo === 'Inconsistências';
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
      return;
    }
    this.filtrar();
  },
};
</script>

<style>
.Container_Nivel1_Notas .Container_Cards {
  padding: 1em 4px 7px 4px;
}
.Container_Nivel1_Notas .Card_Recebimento {
  min-height: 9.5em;
}
.Container_Nivel1_Notas .Card_Title, .Container_Nivel1_Notas .Card_Content {
  color: #757575;
  text-align: center;
  display: block;
  padding: 0;
}
.Container_Nivel1_Notas .Card_Title p {
  font-size: 1.1em;
  font-weight: 500;
  padding: 0;
  margin: 0px;
}
.Container_Nivel1_Notas .Card_Content p {
  font-size: 1.5em;
  font-weight: 300;
  padding: 0;
  margin: 0px;
}
.Container_Nivel1_Notas .Card_Actions {
  min-height: 1em;
}
.Container_Nivel1_Notas .Card_Actions button, .Container_Nivel1_Notas .Card_Actions span {
  min-width: 12%;
  width: 25px;
  font-size: 18px;
  text-align: center;
}
.Container_Nivel1_Notas .Card_Actions button {
  color: dimgray;
}
.clickable {
  cursor: pointer;
}
.botaoInconsistencia {
  height: 2em !important;
  width: 2em !important;
  font-size: small !important;
  color: white !important;
}
.NotasExportacao__SelecaoPeriodo {
  width: auto;
}
</style>
